import styled from 'styled-components';
import { lightGrey3Color } from 'js/config/style';

export default styled.div`
  text-align: center;
  max-width: 100%;
  margin: 1.5rem auto;
  font-size: 0.8rem;
  color: ${lightGrey3Color};
  cursor: pointer;
  user-select: none;
  padding: 0.5rem 0;

  &:hover {
    text-decoration: underline;
  }
  &:active {
    text-decoration: none;
  }
`;
